export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_12.03beec27.jpg";